import React, { useEffect, useState } from 'react'
import '../spare/cu-spare.scss'
import NormalInput from '../../common/inputs/NormalInput'
import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'


const UpdatePackageRate = ({ spare_id, currentData, setModal }) => {
    const [itemForm, setItemForm] = useState({})
    const [packages, setPackage] = useState([])


    const handleChangeItemForm = (e) => {
        setItemForm({
            ...(itemForm || {}),
            [e.target.name]: e.target.value
        })
    }

    const handleAddItem = () => {
        if (!itemForm?.package_id || !itemForm?.price) {
            return;
        }

        const existed = (packages || [])?.find(i => i?.package_id === itemForm?.package_id)
        if (existed) {
            toast.error('The Package already exited')
            return
        }

        setPackage([
            ...packages,
            itemForm
        ])

        setItemForm({})
    }

    const removeItem = (package_id) => {
        setPackage((packages || [])?.filter(i => i?.package_id !== package_id))
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const body = {
            package_pricing: packages || [],
        }

        customerAxios.put(`/production-v0/spare/${spare_id}/package-rate`, body).then(() => {
            setModal({ status: false })
            toast.success(`Spare Updated! \n Refresh and Reopen the Spare to View`)

        }).catch((error) => {
            toast.error(error.message)
        })

    }

    useEffect(() => {

        setPackage(currentData?.map(p => ({ package_id: p?.package_id, price: p?.price || 0 })))

        // eslint-disable-next-line
    }, [currentData])


    return (
        <div className="cu-spare-sub-div">
            <form action="" onSubmit={handleSubmit}>
                <div className="item-list-div">
                    <table>
                        <tbody>
                            {(packages || [])?.map((item) => {
                                return <tr>
                                    <td>PKG ID : {item?.package_id}</td>
                                    <td>Price : {item?.price}</td>
                                    <td>
                                        <button type='button' onClick={() => removeItem(item?.package_id)}>
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="add-item-div">
                    <NormalInput label='Package Id' name='package_id' value={itemForm?.package_id} onChangeFun={handleChangeItemForm} isRequired={false} />
                    <NormalInput label='Price' name='price' value={itemForm?.price} onChangeFun={handleChangeItemForm} isRequired={false} type={'number'} min={0} />
                    <button type='button' onClick={handleAddItem}>Add Rate</button>
                </div>
                <button>Submit</button>
            </form>
        </div>
    )
}

export default UpdatePackageRate